const pad2 = (value: number): string => value.toString().padStart(2, '0')

const clamp = (value: number, min: number, max: number): number =>
    Math.min(Math.max(value, min), max)

const daysInMonth = (year: number, month1to12: number): number =>
    new Date(year, month1to12, 0).getDate()

export const maskDateTime = (input: string): string => {
    const digits = input.replace(/\D/g, '').slice(0, 12)

    const year = digits.slice(0, 4)
    let month = digits.slice(4, 6)
    let day = digits.slice(6, 8)
    let hour = digits.slice(8, 10)
    let minute = digits.slice(10, 12)

    if (month.length === 2) {
        month = pad2(Math.min(Number(month), 12))
    }
    if (day.length === 2) {
        const monthNum = Number(month)
        const maxDay =
            year.length === 4 && month.length === 2 && monthNum >= 1
                ? daysInMonth(Number(year), monthNum)
                : 31
        day = pad2(Math.min(Number(day), maxDay))
    }
    if (hour.length === 2) {
        hour = pad2(Math.min(Number(hour), 23))
    }
    if (minute.length === 2) {
        minute = pad2(Math.min(Number(minute), 59))
    }

    let result = year
    if (digits.length > 4) {
        result += `-${month}`
    }
    if (digits.length > 6) {
        result += `-${day}`
    }
    if (digits.length > 8) {
        result += ` ${hour}`
    }
    if (digits.length > 10) {
        result += `:${minute}`
    }
    return result
}

export const parseClampedDateTime = (text: string): Date | null => {
    const match = text.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/)
    if (!match) {
        return null
    }
    const [, y, mo, d, h, mi] = match
    const year = Number(y)
    const month = clamp(Number(mo), 1, 12)
    const day = clamp(Number(d), 1, daysInMonth(year, month))
    const hour = clamp(h ? Number(h) : 0, 0, 23)
    const minute = clamp(mi ? Number(mi) : 0, 0, 59)
    const date = new Date(year, month - 1, day, hour, minute, 0, 0)
    return Number.isNaN(date.getTime()) ? null : date
}
